import { Settings, settingType } from "../../../../../hooks/useSettingsToggle";

export const freeformSettings: Settings = {
  imageCropping: settingType.cpatonly,
  interactivity: settingType.cpatonly,
  timeline: settingType.cpatonly,
  tables: settingType.cpatonly,
};
